<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="d_flex_btwn">
          <h5 class="common_subtitle pb_20  font_16p pt_20">Policy Group</h5>
        </div>

        <div class="d_flex_start pt_10 pb_10">
          <button v-if="can('policy_group_create')" type="button" class="btn btn-outline-primary btn-sm mr_15 width_150p" @click="openModal()">
            Create Policy Group
          </button>
          <button v-if="can('policy_group_edit')" type="button" class="btn btn-outline-primary btn-sm mr_15 width_100p" @click.prevent="openModal(selectedRecord.id)"
                  :disabled="!selectedRecord || !selectedRecord.id">
            Edit
          </button>
          <button v-if="can('policy_group_delete')" type="button" class="btn btn-outline-danger btn-sm mr_15 width_100p" @click.prevent="deleteRecord()"
                  :disabled="!selectedRecord || !selectedRecord.id">
            Delete
          </button>
          <button v-if="can('policy_group_view_permission')" type="button" class="btn btn-outline-info btn-sm mr_15 width_260p"
                  @click.prevent="viewPolicyInfo(selectedRecord)" :disabled="!selectedRecord || !selectedRecord.id">
            View Policy
          </button>
          <button type="button" class="btn btn-outline-primary btn-sm width_100p" @click.prevent="loadData()">
            Refresh
          </button>
        </div>

        <cloud-table-component
            :columns="columns"
            :rows="inquiries"
            :sortable="sortable"
            :pagination="pagination"
            @sorting="sorting"
            @pageChanged="pageChanged">
          <template v-slot:id="{ row }">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" :id="'action_'+row.id"
                     @focus="checkSingleData(row, $event)" :checked="selectedRecord?.id === row.id">
              <label class="form-check-label" :for="'action_'+row.id"></label>
            </div>
          </template>

          <template v-slot:policies="{ row }">
            {{ formattedText(row?.policies) }}
          </template>

        </cloud-table-component>
      </div>
    </div>

    <BaseModal
        v-if="isShowInquiryModal"
        :title="modalTitle"
        :closeModal="closeModal"
        size="modal_1080p"
    >
      <PolicyGroupForm
          :closeModal="closeModal"
          :loadData="loadData"
          :editId="editId"
      />
    </BaseModal>

  </div>
</template>

<script>
import CloudTableComponent from "@/components/shared/CloudTableComponent.vue";
import PolicyGroupForm from "@/views/iam/PolicyGroupForm.vue";
import BaseModal from "@/components/BaseModal.vue";
import { useAbility } from '@casl/vue';
import {mapGetters} from "vuex";

export default {
  name: "PolicyGroup",
  components: {BaseModal, PolicyGroupForm, CloudTableComponent},
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
  data() {
    return {
      inquiries: [],
      filter: {},
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'user_id,email,phone,policy.name,policyGroup.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      },
      sortable: {
        order: 'created_at',
        sort: 'desc'
      },
      columns: [
        {
          label: "",
          field: "id",
          sortable: false,
          slot: true,
        },
        {
          label: "Policy Group Name",
          field: "name",
          sortable: true,
        },
        {
          label: "Policies",
          field: "policies",
          slot: true,
        },
        {
          label: "Explanation",
          field: "description",
          sortable: true,
        },
      ],
      pagination: null,
      isShowInquiryModal: false,
      editId: null,
      selectedRecord: null
    }
  },
  watch: {
    $route(to, from) {
      if (to.name === from.name && !window._.isEqual(to, from)) {
        this.setQueryData(this.getAllQueryParams())
        this.loadData()
      }
    },
  },
  computed: {
    modalTitle() {
      if (this.editId) {
        return 'Edit Policy Group';
      } else {
        return 'Add New Policy Group';
      }
    },
    ...mapGetters({
      customer: 'auth/getUser'
    })
  },
  mounted() {
    const query = this.getAllQueryParams()
    if (query.page) {
      this.setQueryData(query)
    }
    this.loadData()
  },
  methods: {
    setQueryData(query) {
      this.queryParams = {
        page: query.page,
        search: query.search,
        search_columns: query.search_columns,
        sort: query.sort,
        sort_order: query.sort_order,
        per_page: query.per_page
      }

      this.filter = {}

      this.sortable = {
        order: query.sort,
        sort: query.sort_order
      }
    },
    resetAll() {
      this.sortable = {
        order: 'created_at',
        sort: 'desc'
      }

      this.filter = {}

      this.queryParams = {
        page: 1,
        search: '',
        search_columns: 'user_id,email,phone,policy.name,policyGroup.name',
        sort: 'created_at',
        sort_order: 'desc',
        per_page: 10
      }

      this.changeRoute();
      this.loadData();
    },
    searchQuery() {
      this.changeRoute();
    },
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
      this.queryParams.page = 1;
      this.changeRoute()
    },
    pageChanged(page) {
      this.queryParams.page = page;
      this.changeRoute()
    },
    changeRoute() {
      this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
    },
    loadData() {
      this.lyLoading = true
      this.axios.get('/policy-groups', {
        params: {...this.queryParams, ...this.filter}
      })
          .then(({data}) => {
            this.inquiries = data.data
            this.pagination = data.meta;
          })
          .finally(() => {
            this.lyLoading = false;
            this.selectedRecord = null;
          })
    },
    openModal(editId = null) {
      this.editId = editId
      this.isShowInquiryModal = true;
    },
    closeModal() {
      this.isShowInquiryModal = false;
    },
    checkSingleData(user, event) {
      event.target.blur();
      if (this.selectedRecord?.id === user.id) {
        this.selectedRecord = null;
      } else {
        this.selectedRecord = user;
      }
    },
    deleteRecord() {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/policy-groups/' + this.selectedRecord.id)
              .then((response) => {
                if (response.data.success) {
                  this.selectedRecord = null;
                  this.showSuccessMsg(response.data.message);
                  this.loadData();
                } else {
                  this.showFailMsg(response.data.message)
                }
              });
        }
      });
    },
    viewPolicyInfo(group) {

      const permissionList = group.policies.map(permission =>
          `<div><a href="#"> ${permission.name}</a></div>`).join('');

      this.$swal({
        title: "Policies",
        html: `<div>${permissionList}</div>`,
      });
    },
    formattedText(texts) {
      if (texts?.length) {
        return texts.map((item) => item.name).join(', ')
      }
    }
  }
}
</script>

<style scoped>

</style>